export default __webpack_public_path__ + "static/media/create-course-disabled.57bb70b7.svg";